import Form from "react-bootstrap/Form";
import { useForm } from "react-hook-form";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useWindowSize } from "react-use";
import convertToEnglishNumbers from "../../../../function/convertToEnglishNumbers";

const NavPillTrack = () => {
  const { width } = useWindowSize();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const orderId = params.get("id");

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const handleOrderIdChange = e => {
    const value = convertToEnglishNumbers(e.target.value);
    setValue("orderId", value, {
      shouldValidate: true,
      shouldDirty: true,
    });
  };

  return (
    <form
      onSubmit={handleSubmit(values => {
        const url = `/tracking?id=${values.orderId}`;
        if (values.orderId === orderId) {
          window.location.href = url;
          return;
        }

        navigate(url);
      })}
    >
      <div className="d-flex flex-wrap mt-2">
        <Form.Control
          style={{ fontSize: width > 767 ? 16 : 14 }}
          className="w-100 w-md-75 border border-2 rounded-0"
          size="lg"
          type="text"
          placeholder="شماره سفارش یا بارکد خود را وارد کنید"
          defaultValue={orderId}
          {...register("orderId", {
            required: { value: true, message: "شماره سفارش یا بارکد الزامی" },
          })}
          onChange={handleOrderIdChange}
        />
        <button
          type="submit"
          className="w-100 w-md-25 btn-success-style rounded-0"
        >
          جستجو
        </button>
      </div>
      {errors.orderId && (
        <p className="fs-small text-danger">{errors.orderId.message}</p>
      )}
    </form>
  );
};
export default NavPillTrack;
